import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  ViewController,
  AlertController,
} from "ionic-angular";
import { Deviation } from "../../models/deviation";
import { Site, Customer, Train, NavEntity } from "../../models";
import { Subscription } from "rxjs";
import { forkJoin } from "rxjs/observable/forkJoin";
import { StarmsClientProvider } from "../../providers/starms-client/starms-client";
import { Case } from "../../models/case";
import { EntitiesProvider } from "../../providers/entities/entities";

import * as moment from "moment";

/**
 * Generated class for the InstrumentHealthPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: "page-instrument-health",
  templateUrl: "instrument-health.html",
})
export class InstrumentHealthPage {
  constructor(
    private starmsClientService: StarmsClientProvider,
    public navCtrl: NavController,
    public navParams: NavParams,
    private entitiesProvider: EntitiesProvider,
    private viewCtrl: ViewController,
    private alertCtrl: AlertController,
    private starms: StarmsClientProvider
  ) {}

  nav: NavEntity;
  filter: "all" | "open" | "closed" = "all";
  openDeviations: Array<Deviation> = [];
  closedDeviations: Array<Deviation> = [];
  ready = false;
  public currentWindowWidth: number;
  type: string;
  current: Site | Customer | Train;
  subscription: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  totalDeviations: number;
  eMail = "";
  entityId: number;
  userId: number;
  myPageView: String;
  allInfo: String;
  userType: String;
  pageViewName = " ";
  value: String = "all";

  trainId: number;
  case: Object;
  openDeviationInformations: any[] = [];
  closedDeviationInformations: any[] = [];
  visibilities = new Map<number, boolean>();

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.nav = this.entitiesProvider.currentEntity;

    this.subscription2 = forkJoin(
      this.starmsClientService.get(["myhealth", "deviations"], {
        trainId: this.nav.getId(),
        from: "2016-01-01",
        to: moment().format("YYYY-MM-DD HH:mm:ss"),
        status: 0,
        application: 8,
      }),
      this.starmsClientService.get([
        "signals/signaltags",
        this.nav.getType() + "s",
        this.nav.getId(),
      ])
    ).subscribe(([deviations, tags]) => {
      for (const dev of deviations) {
        this.totalDeviations = 0;

        const titleRegex = /\([A-Za-z0-9]SC[A-Za-z0-9]\)/g;

        if (
          (titleRegex.test(dev.title) && dev.caseId) ||
          (dev.deviationFaultType === "Sensor Fault" && dev.tagAlias)
        ) {
          // (dev.title.includes('(H SC)') || dev.title.includes('(M SC)') || dev.title.includes('(L SC)')) && dev.caseId

          // deserializes deviation
          const newDev = new Deviation().deserialize(dev);

          // removes the parenthesis part of the title
          newDev.title = newDev.title.substring(7, newDev.title.length);

          // transforms Tag Alias string into an array
          newDev.tagAlias = newDev.tagAlias.split(", ");

          // initializes Tag Alias Array
          newDev.tagAliasArray = [];

          // gets all tags related to tagAlias
          newDev.tagString = "";

          for (const tag of tags) {
            for (let j = 0; j < newDev.tagAlias.length; j++) {
              if (tag.tagAlias === newDev.tagAlias[j]) {
                newDev.tagAliasArray.push(tag);
                newDev.tagString =
                  newDev.tagString +
                  " " +
                  tag.customerTagAlias +
                  " (" +
                  tag.tagDescription +
                  "),";
              }
            }
          }

          // gets caseNumber of the caseId
          if (dev.caseId) {
            this.subscription3 = this.starmsClientService
              .get(["cases", newDev.caseId])
              .subscribe((uniqueCase: Case) => {
                newDev.caseNumber = uniqueCase.caseNumber;

                newDev.tagString = newDev.tagString.substring(
                  1,
                  newDev.tagString.lastIndexOf(",")
                );
              });
          }

          if (
            newDev.status.includes("New") ||
            newDev.status.includes("Acknowledged")
          ) {
            this.openDeviations.push(newDev);
            newDev["open"] = false;
            this.openDeviationInformations.push(newDev);
          } else {
            this.closedDeviations.push(newDev);
            newDev["open"] = false;
            this.closedDeviationInformations.push(newDev);
          }

          // this.totalDeviations += 1;
        }
      }

      if (this.openDeviations) {
        this.openDeviations = this.openDeviations.filter(function (
          obj,
          index,
          self
        ) {
          return (
            index ===
            self.findIndex(function (t) {
              return (
                t.tagAliasArray[0].tagName === obj.tagAliasArray[0].tagName
              );
            })
          );
        });
      }
      if (this.closedDeviations) {
        this.closedDeviations = this.closedDeviations.filter(function (
          obj,
          index,
          self
        ) {
          return (
            index ===
            self.findIndex(function (t) {
              return (
                t.tagAliasArray[0].tagName === obj.tagAliasArray[0].tagName
              );
            })
          );
        });
      }

      this.totalDeviations =
        this.openDeviations.length + this.closedDeviations.length;
      this.openDeviations.sort(
        (first: Deviation, second: Deviation) =>
          new Date(second.createdOn).getTime() -
          new Date(first.createdOn).getTime()
      );
      this.openDeviationInformations = this.openDeviationInformations
        .filter(
          (value: Deviation, index: number) =>
            this.openDeviations.indexOf(value) != -1
        )
        .sort(
          (first: Deviation, second: Deviation) =>
            new Date(second.createdOn).getTime() -
            new Date(first.createdOn).getTime()
        );
      this.closedDeviations.sort(
        (first: Deviation, second: Deviation) =>
          new Date(second.createdOn).getTime() -
          new Date(first.createdOn).getTime()
      );
      this.closedDeviationInformations = this.closedDeviationInformations
        .filter(
          (value: Deviation, index: number) =>
            this.closedDeviations.indexOf(value) != -1
        )
        .sort(
          (first: Deviation, second: Deviation) =>
            new Date(second.createdOn).getTime() -
            new Date(first.createdOn).getTime()
        );

      this.ready = true;
    });
  }

  async presentAlert(element: any) {
    let alert = this.alertCtrl.create({
      title: element.title,
      message: element.message,
      buttons: [
        {
          text: "Do not show again",
          role: "cancel",
          handler: () => {
            this.visibilities[element.id] = false;
            localStorage.setItem(
              "visibilities",
              JSON.stringify(this.visibilities)
            );
          },
        },
        {
          text: "Dismiss",
          role: "dismiss",
          handler: () => {},
        },
      ],
    });
    await alert.present();
  }

  changeFilter(option: "all" | "open" | "closed"): void {
    this.filter = option;
  }

  onBackClick() {
    this.trainId = this.current.getId();
    this.navCtrl.push("train/" + this.trainId + "/overview");
  }

  dismiss(): void {
    this.viewCtrl.dismiss();
  }

  toggleOpenDeviationSections(index) {
    this.openDeviationInformations[index].open =
      !this.openDeviationInformations[index].open;
  }

  toggleClosedDeviationSections(index) {
    this.closedDeviationInformations[index].open =
      !this.closedDeviationInformations[index].open;
  }
}



// WEBPACK FOOTER //
// ./src/pages/instrument-health/instrument-health.ts